/*!
 * jQuery UI Widget-factory plugin boilerplate (for 1.8/9+)
 * Author: @addyosmani
 * Further changes: @peolanha
 * Licensed under the MIT license
 */

(function ($, window, document, undefined) {

	// define your widget under a namespace of your choice
	//  with additional parameters e.g.
	// $.widget( "namespace.widgetname", (optional) - an
	// existing widget prototype to inherit from, an object
	// literal to become the widget's prototype );

	$.widget("badMath.scrollManager", {

		_scrollTop: 0,
		_lastScrollTop: 0,

		_scrollHeight: 0,
		_dfdPageRender: null,
		_firstDisplayedItem: 0,
		_lastDisplayedItem: 0,
		_firstDisplayedPage: Number.MAX_VALUE,
		_lastDisplayedPage: 0,
		_numPages: 0,
		_totalNumResults: 0,
		_numDisplayedPages: 0,
		_windowHeight: 0,

		//Options to be used as defaults
		options: {
			pageElSelector: '.resultPage',
			getNumDisplayedPages: function () {},
			currentPage: 0,
			currentItem: 0, //id of the current item.
			pageSize: 10, //the number of records in a page
			removePages: true,
			maximumDisplayedPages: 4,
			numPagesToRemove: 1,
			sizeUnit: 'em',
			minItemHeight: 5, //the minimum height of an item
			fixedHeight: false, //boolean indicating whether or not the item height is fixed
			//renderOverflowSize: 3, //number of items to render above and below the viewport
			getNewPageScrollOffset: 300, //the distance from the bottom or the top the scroll position should be to trigger the retrival of new results
			disableAutoloadClass: '', //if a parent of the scrolling element has this class, no new pages will be loaded.
			getItemElement: function (item, index) {}, //renders an item
			renderItemPlaceHolder: function (item) {}, //renders an item placeholder
			getPageHeader: function (pageNum, numPages) {}, //renders pagination controls
			getLoadingPageDisplay: function () {},
			getData: function (offset, count) {}, //returns a deferred object which will be resolved when count items are retrieved starting from offset.
			estimateItemHeight: function (item) {}, //returns the estimated height of an item. 
			afterInit: function (data) {},
			afterPageChange: function (newPageNum) {},
			scrollHandler: function (scrollTop) {},
			getPage: function (data) {},
			afterPageDrawn: function (page) {},
			showPreviousPageOnJump: true,
			scrollToPageOffset: 300,
			noDataHandler: function () {},
			startLoading: function () {},
			finishLoading: function (data) {},
			getTotalCount: function (data) {
				return data.numFound;
			},
			getNumResults: function (data) {
				return data.docs.length;
			},
			getPageStart: function (data) {
				return parseInt(data.start);
			},
			debug: false
		},

		//Setup widget (eg. element creation, apply theming
		// , bind events etc.)
		_create: function () {
			var plugin = this;

			var startOffset = Math.max(0, (plugin.options.currentPage - 1) * plugin.options.pageSize);
			var recordsToRetrieve = plugin.options.pageSize;

			if (plugin.options.showPreviousPageOnJump && plugin.options.currentPage > 1) {
				startOffset -= plugin.options.pageSize;
				recordsToRetrieve += plugin.options.pageSize;
			}
			plugin.options.startLoading();

			$.when(plugin.options.getData(startOffset, recordsToRetrieve)).done(function (response) {
				plugin._initialize(response);
				plugin._bindScrollEvents();
				plugin.options.finishLoading(response);
			});

		},

		// Destroy an instantiated plugin and clean up
		// modifications the widget has made to the DOM
		_destroy: function () {
			this.element.removeClass('scrollManager firstPage');
			$(document).unbind('.scrollManager');

		},

		_initialize: function (data) {
			var plugin = this,
				page, prevPage,
				dataStart = plugin.options.getPageStart(data),
				numResults = plugin.options.getNumResults(data);

			if (numResults === 0) {
				plugin.options.noDataHandler();
				plugin.options.afterInit(data);
				return;
			}

			plugin.element.empty();
			plugin.element.addClass('scrollManager');
			plugin._firstDisplayedItem = dataStart;
			plugin._lastDisplayedItem = dataStart + numResults - 1;

			plugin._numDisplayedPages = 0;

			plugin._totalNumResults = plugin.options.getTotalCount(data);
			plugin._numPages = Math.ceil(plugin._totalNumResults / plugin.options.pageSize);

			var startPage = dataStart / plugin.options.pageSize;
			if (numResults > plugin.options.pageSize && plugin.options.showPreviousPageOnJump &&
				plugin.options.currentPage > 1) {
				prevPage = plugin._createPage(dataStart, data);
				plugin.element.append(prevPage);
				plugin.options.afterPageDrawn(prevPage);

				page = plugin._createPage(dataStart + plugin.options.pageSize,
					data, plugin.options.pageSize);
				plugin.element.append(page);
				plugin.options.afterPageDrawn(page);
				plugin.setScrollPos(page.position().top);
			} else {
				page = plugin._createPage(dataStart, data);
				plugin.element.append(page);
				plugin.options.afterPageDrawn(page);
			}

			plugin._numDisplayedPages = plugin.options.getNumDisplayedPages();
			plugin._scrollHeight = $(document).height();
			plugin._windowHeight = $(window).height();

			plugin.options.afterInit(data);
		},

		_bindScrollEvents: function () {
			var plugin = this;

			$(window).on('resize.scrollManager', function () {
				plugin._windowHeight = $(window).height();
			});
			plugin._animloop();

		},

		_animloop: function () {
			var plugin = this;
			plugin._scrollTop = window.pageYOffset; //$(document).scrollTop();
			plugin.options.currentPage = plugin.options.scrollHandler(plugin._scrollTop);

			function loadPages() {
				var dfd = null;
				if (plugin.options.debug) {
					$('.debug').html(
						'time: ' + new Date().getTime() + '<br/>' +
						'scrollTop: ' + plugin._scrollTop + '<br/>' +
						'scrollHeight: ' + plugin._scrollHeight + '<br/>' +
						'windowHeight: ' + plugin._windowHeight + '<br/>' +
						'top getPageOffset: ' + (plugin.options.getNewPageScrollOffset + plugin.element.offset()
							.top) + '<br/>' +
						'bottom pos: ' + (plugin._scrollTop + plugin._windowHeight) + '<br/>' +
						'bottom getPageOffset: ' + (plugin._scrollHeight - plugin.options.getNewPageScrollOffset) +
						'<br/>' +
						'pages displayed: ' + (plugin._firstDisplayedPage + '-' + plugin._lastDisplayedPage) +
						'<br/>' +
						'deferred status: ' + (plugin._dfdPageRender ? plugin._dfdPageRender.state() :
							'not set'));
				}

				if (plugin.options.disableAutoloadClass && plugin.element.closest('.' + plugin.options.disableAutoloadClass)
					.length) {
					dfd = true;
				} else if (plugin._firstDisplayedPage > 1 && plugin._scrollTop < plugin.options.getNewPageScrollOffset +
					plugin.element.offset().top) {

					dfd = plugin.addPage('above');
				} else if (plugin._scrollTop + plugin._windowHeight > plugin._scrollHeight - plugin.options
					.getNewPageScrollOffset) {
					dfd = plugin.addPage('below');
				} else {
					dfd = true;
				}
				$.when(dfd).done(function () {
					window.requestAnimationFrame(function () {
						plugin._animloop();
					});
				});
			}

			loadPages();
		},

		_createPage: function (pageStartOffset, data, startIndex) {
			if (startIndex === undefined) {
				startIndex = 0;
			}
			var plugin = this;
			var pageNum = (pageStartOffset / plugin.options.pageSize) + 1;
			if (pageNum < plugin._firstDisplayedPage) {
				plugin._firstDisplayedPage = pageNum;
				if (plugin._firstDisplayedPage == 1) {
					plugin.element.addClass('firstPage');
				} else {
					plugin.element.removeClass('firstPage');
				}
			}

			if (pageNum > plugin._lastDisplayedPage) {
				plugin._lastDisplayedPage = pageNum;
			}
			return plugin.options.getPage(data, pageNum, pageStartOffset, startIndex);

		},

		removePages: function (which) {
			var dfd = new $.Deferred();
			var plugin = this;

			if (!plugin.options.removePages) {
				return;
			}

			switch (which) {
			case 'bottom':
				var children = plugin.element.children(plugin.options.pageElSelector);
				var bottomPages = children.slice(children.length - plugin.options.numPagesToRemove);
				bottomPages.remove();
				plugin._numDisplayedPages = plugin.element.children(plugin.options.pageElSelector).length;
				plugin._scrollHeight = $(document).height();
				var newLastPage = plugin.element.children(plugin.options.pageElSelector).last();
				plugin._lastDisplayedItem = newLastPage.data('firstItem') + newLastPage.children(
					'.searchResult').length - 1;
				plugin._lastDisplayedPage = Number(newLastPage.data('pageNum'));
				return true;
			case 'top':
				var topPages = plugin.element.children(plugin.options.pageElSelector).slice(0, plugin.options
					.numPagesToRemove);
				var topPagesHeight = 0;
				topPages.each(function () {
					topPagesHeight += $(this).height();
				});
				topPages.remove();
				var newFirstPage = plugin.element.children(plugin.options.pageElSelector).first();
				plugin._firstDisplayedItem = newFirstPage.data('firstItem');
				plugin._firstDisplayedPage = Number(newFirstPage.data('pageNum'));
				plugin._numDisplayedPages = plugin.element.children(plugin.options.pageElSelector).length;
				plugin._scrollHeight = $(document).height();
				setTimeout(function () {
					plugin.setScrollPos(plugin._scrollTop - topPagesHeight - parseInt(plugin.element.css(
						'padding-top'), 10));
					dfd.resolve();
				}, 0);
				break;
			}
			return dfd.promise();
		},

		addPage: function (which) {

			var plugin = this;
			var newPage = null;
			var pageNum;

			if (plugin._dfdPageRender && plugin._dfdPageRender.state() != 'resolved') {
				return;
			}
			plugin._dfdPageRender = new $.Deferred();
			//var loadingPage =
			var origScrollTop = window.pageYOffset;
			var placeHolderHeight = 0;

			var startOffset = 0;
			switch (which) {
			case 'above':
				if (plugin._firstDisplayedPage == 1) {
					plugin._dfdPageRender.resolve();
					return;
				}
				startOffset = Math.max(0, plugin._firstDisplayedItem - plugin.options.pageSize);
				if (startOffset == plugin._firstDisplayedItem) {
					plugin._dfdPageRender.resolve();
					return;
				}
				pageNum = plugin._firstDisplayedPage - 1;
				newPage = plugin.options.getLoadingPageDisplay(pageNum, startOffset);

				plugin.element.prepend(newPage);
				break;
			case 'below':
				if (plugin._lastDisplayedPage == plugin._numPages) {
					plugin._dfdPageRender.resolve();
					return;
				}
				startOffset = plugin._lastDisplayedItem + 1;
				if (startOffset >= plugin._totalNumResults) {
					plugin._dfdPageRender.resolve();
					return;
				}
				pageNum = plugin._lastDisplayedPage + 1;
				newPage = plugin.options.getLoadingPageDisplay(pageNum, startOffset);
				plugin.element.append(newPage);
				break;
			}

			$('.debug').text('add Page pending');
			$.when(plugin.options.getData(startOffset, plugin.options.pageSize)).done(function (response) {
				var page = plugin._createPage(startOffset, response);
				switch (which) {
				case 'above':
					plugin._firstDisplayedItem = startOffset;
					break;
				case 'below':
					plugin._lastDisplayedItem = startOffset + plugin.options.getNumResults(response) - 1;
					break;
				}

				function updateScrollPos() {
					var dfd = new $.Deferred();

					if (which == 'above') {
						plugin.setScrollPos(window.pageYOffset + $('.placeHolder').outerHeight(true), false);
						if (plugin.options.maximumDisplayedPages && plugin._numDisplayedPages >= plugin.options
							.maximumDisplayedPages) {
							plugin.removePages('bottom');
						} else {
							plugin._numDisplayedPages++;
						}
						return true;

					} else {

						if (plugin.options.maximumDisplayedPages && plugin._numDisplayedPages >= plugin.options
							.maximumDisplayedPages) {
							$.when(plugin.removePages('top')).done(dfd.resolve());
						} else {
							plugin._numDisplayedPages++;
							return true;
						}
					}
					return dfd.promise();
				}

				//put the new page somewhere to get its height;
				plugin.element.append($('<div/>').addClass('placeHolder').append(page));

				newPage
					.removeClass('loadingPage')
					.removeClass('topLoadingPage')
					.css('height', $('.placeHolder').outerHeight(true));

				if (Modernizr.touch) {
					//The ipad2 is slow in setting the scroll position, so set the height
					//of the loading page to the height of the new page and remove its
					//absolute positioning while maintaining the current scroll pos 
					//(when the new page is on top this will cause the viewport to be empty)
					//wait for a redraw, then update the scroll position to what it 
					//should be and replace the contents with the new page.
					setTimeout(function () {
						$.when(updateScrollPos()).done(function () {
							newPage.replaceWith(page);
							$('.placeHolder').remove();
							newPage.css('height', '');
							plugin._scrollHeight = $(document).height();
							plugin.options.afterPageDrawn(page);
							plugin._dfdPageRender.resolve();
							$('.debug').text('add Page resolved');
						});
					}, 0);

					//don't use a timeout for desktops since it causes an unecessary
					//redraw so the scrolling does not appear smooth.
				} else {
					updateScrollPos();
					newPage.replaceWith(page);
					$('.placeHolder').remove();
					newPage.css('height', '');
					plugin._scrollHeight = $(document).height();
					plugin.options.afterPageDrawn(page);

					plugin._dfdPageRender.resolve();
					$('.debug').text('add Page resolved');
				}
			});
			return plugin._dfdPageRender.promise();
		},

		setScrollPos: function (pos, addOffset) {
			var plugin = this;

			if (addOffset === undefined) {
				addOffset = true;
			}
			$(window).scrollTop(pos + (addOffset ? plugin.element.offset().top - plugin.options.scrollToPageOffset :
				0));
			plugin._scrollTop = $(window).scrollTop();
		},

		//pageNum is 1 based.
		goToPage: function (pageNum, callback) {

			var plugin = this;
			var pageEl = plugin.element.find(plugin.options.pageElSelector + pageNum);
			if (pageEl.length) {
				plugin.setScrollPos(pageEl.position().top);
				plugin.options.currentPage = pageNum;
			} else {
				if (pageNum > plugin._numPages) {
					pageNum = plugin._numPages;
				} else if (pageNum < 1) {
					pageNum = 1;
				}
				var startOffset = (pageNum - 1) * plugin.options.pageSize;
				var numRecoordsToGet = plugin.options.pageSize;
				if (plugin.options.showPreviousPageOnJump && pageNum > 1) {
					startOffset -= plugin.options.pageSize;
					numRecoordsToGet += plugin.options.pageSize;
				}
				plugin.options.startLoading();
				$.when(plugin.options.getData(startOffset, numRecoordsToGet)).done(function (response) {
					plugin._firstDisplayedItem = startOffset;
					plugin._firstDisplayedPage = Number.MAX_VALUE;
					plugin._lastDisplayedPage = 0;
					plugin._lastDisplayedItem = startOffset + plugin.options.getNumResults(response) - 1;
					plugin.element.find(plugin.options.pageElSelector).remove();
					plugin._numDisplayedPages = 0;
					var page = null;

					if (plugin.options.showPreviousPageOnJump && pageNum > 1) {
						var prevPage = plugin._createPage(startOffset, response);
						plugin.element.append(prevPage);
						plugin.options.afterPageDrawn(prevPage);

						plugin._numDisplayedPages++;

						page = plugin._createPage(startOffset + plugin.options.pageSize, response, plugin.options
							.pageSize);
						plugin.element.append(page);
						plugin.options.afterPageDrawn(page);
						plugin._numDisplayedPages++;

					} else {

						page = plugin._createPage(startOffset, response);
						plugin.element.append(page);
						plugin.options.afterPageDrawn(page);

						plugin._numDisplayedPages++;
					}
					plugin._scrollHeight = $(document).height();
					plugin.setScrollPos(page.position().top);
					plugin.options.currentPage = pageNum;
					plugin.options.finishLoading(response);
					if (callback !== undefined) {
						callback();
					}
				});
			}
		},

		update: function (data) {
			var plugin = this;
			plugin.options.currentPage = 1 + (data.start / plugin.options.pageSize);
			plugin._initialize(data);
		},

		updateScrollHeight: function () {
			var plugin = this;
			plugin._scrollHeight = $(document).height();
		},

		getCurrentStatus: function () {
			var plugin = this;
			return {
				numPages: plugin._numPages,
				firstDisplayedPage: plugin._firstDisplayedPage,
				lastDisplayedPage: plugin._lastDisplayedPage,
				pageSize: plugin.options.pageSize
			};
		},

		// Respond to any changes the user makes to the
		// option method
		_setOption: function (key, value) {
			switch (key) {
			case "someValue":
				//this.options.someValue = doSomethingWith( value );
				break;
			default:
				//this.options[ key ] = value;
				break;
			}
			this._super("_setOption", key, value);
		}
	});

})(jQuery, window, document);
